import React from 'react';

const CustomerComponent = () => {
    return <div>Customer component</div>;
};

export default CustomerComponent;
